import { SVGRenderer } from '../../renderers/SVGRenderer';
import { registerRenderer } from '../../registry/renderers';
export var svgPlugin = {
    name: 'lightdraw-svg',
    version: '1.2.1',
    install: function (_LD) {
        registerRenderer('svg', function () { return new SVGRenderer(); });
    },
};
export { SVGRenderer };
export default svgPlugin;
